import { Controller } from '@hotwired/stimulus'

export default class BannerController extends Controller {
  static values = {
    signature: String
  }

  connect() {
    // By default, the banner is hidden to prevent it from appearing and then closing
    // if the user wants to dismiss it.
    if (this.getStateFromLocalStorage() !== 'closed') {
      this.show();
    }
  }

  show() {
    this.element.classList.remove('d-none');
  }

  hide() {
    this.element.classList.add('d-none');
    this.saveStateInLocalStorage();
  }

  saveStateInLocalStorage() {
    localStorage.setItem(`banner_${this.signatureValue}`, 'closed');
  }

  getStateFromLocalStorage() {
    return localStorage.getItem(`banner_${this.signatureValue}`);
  }
}
